import realGetRealMarketContent from './get_real_market_content'

const pendingCalls = []
let ready = false

const COOKIE_CONTROL = 'X-MARKET'
const URL_MARKET_COOKIE = '/ajax_contents/market_cookie'

function flushQueue() {
  for (const { args, resolve, reject } of pendingCalls) {
    realGetRealMarketContent(args).then(resolve).catch(reject)
  }

  pendingCalls.length = 0
}

async function checkMarketCookieReadiness() {
  try {
    const response = await fetch(URL_MARKET_COOKIE, { credentials: 'include' })

    if (!response.ok) return

    const hasXMarket = document.cookie.split(';').some(cookie => cookie.trim().startsWith(`${COOKIE_CONTROL}=`))

    if (hasXMarket) {
      ready = true
      flushQueue()
    }
  } catch (error) {
    console.warn(`[${COOKIE_CONTROL} check failed]', error)`)
  }
}

const getRealMarketContent = args => {
  if (ready) {
    return realGetRealMarketContent(args)
  }

  const cookieAlreadySet = document.cookie.split(';').some(cookie => cookie.trim().startsWith(`${COOKIE_CONTROL}=`))

  if (cookieAlreadySet) {
    ready = true
    return realGetRealMarketContent(args)
  }

  return new Promise((resolve, reject) => {
    pendingCalls.push({ args, resolve, reject })

    if (pendingCalls.length === 1) {
      checkMarketCookieReadiness()
    }
  })
}

export default getRealMarketContent
export { dispatchRealMarketContentUpdatedEvent } from './get_real_market_content'
